import React, { useState } from 'react';
import { GetApp } from '@mui/icons-material';
import { Button, CircularProgress } from '@material-ui/core';

import downloadReport from 'utils/downloadReport';

interface Props {
  shortText: string;
  longText: string;
  type: string;
  fileName: string;
  from?: number;
  to?: number;
  comparison?: boolean;
  period?: string;
  entity: string;
}

const SingleReportRow: React.FC<Props> = (props: Props) => {
  const { shortText, longText, type, fileName, from, to, comparison, period, entity } = props;
  const [downloading, setDownloading] = useState<boolean>(false);

  return (
    <div
      style={{
        display: 'flex',
        fontSize: 14,
        height: 80,
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: 10,
        borderBottom: `1px solid #EBEEF0`,
      }}
    >
      <span style={{ width: 200 }}>{shortText}</span>
      <span style={{ flexGrow: 1 }}>{longText}</span>
      <Button
        variant="outlined"
        color="primary"
        disabled={downloading}
        endIcon={downloading ? <CircularProgress size={17} /> : <GetApp />}
        onClick={(): void => {
          setDownloading(true);
          downloadReport(
            entity,
            {
              export: type,
              sort: 'date',
              order: 'asc',
              from,
              to,
              comparison: comparison || undefined,
              period,
            },
            fileName
          ).then(() => {
            setDownloading(false);
          });
        }}
      >
        Download
      </Button>
    </div>
  );
};

export default SingleReportRow;
